import { useState } from 'react'
import {
  List,
  TextField,
  NumberField,
  FunctionField,
  DatagridConfigurable,
} from 'react-admin'

import EmptyMessage from './EmptyMessage'
import MonthToolbar from './MonthToolbar'
import HippocastListFilters from './HippocastListFilters'

const HippocastList = () => {
  const [selectedMonth, setSelectedMonth] = useState('')
  
  return (
    <List
      disableSyncWithLocation
      resource="hippocast_summary"
      empty={<EmptyMessage />}
      aside={<HippocastListFilters selectedMonth={selectedMonth} />}
      actions={<MonthToolbar selectedMonth={selectedMonth} setSelectedMonth={setSelectedMonth} />}
      sx={{
        '& .RaList-main': {
          overflowX: 'auto',
        },
        '& .MuiTableContainer-root': {
          overflowX: 'auto',
        }
      }}
    >
      <DatagridConfigurable 
        bulkActionButtons={false}
        sx={{
          '& .column-event_name': {
            backgroundColor: '#e7e7e7',
          },
          '& .column-total_sent': {
            backgroundColor: '#d4edda',
          },
          '& .column-total_imported': {
            backgroundColor: '#cfe3f2',
          },
          '& tbody .column-new_leads': {
            backgroundColor: '#f6e9dd',
          },
          '& tbody .column-sub_new_leads': {
            backgroundColor: '#f6e9dd',
          },
          '& tbody .column-crm_leads': {
            backgroundColor: '#f6e9dd',
          },
          '& tbody .column-sub_crm_leads': {
            backgroundColor: '#f6e9dd',
          },
        }}
      >
        <TextField source="event_name" label="Evènement" />
        <FunctionField source="total_sent" label="Total Envoyés" render={record => record.total_sent === 0 ? 'NA' : record.total_sent} />
        <NumberField source="total_imported" label="Total Importé" />

        {/* Hippocast leads count */}
        <NumberField source="new_leads" label="Total Nouveaux" />
        <NumberField source="sub_new_leads" label="Leads Nouveaux Inscrits"
        />
        
        {/* PASS 26-27 fields */}
        <NumberField source="status_breakdown.new_pass_2627" label="PASS 26-27" />
        <NumberField source="status_breakdown.new_pass_2627_ts_2526_done" label="PASS 26-27 + TS 25-26 année passée" />
        <NumberField source="status_breakdown.new_pass_2627_ts_2526" label="PASS 26-27 + TS 25-26" />
        <NumberField source="status_breakdown.new_pass_2627_p0_2526_done" label="PASS 26-27 + P0 25-26 année passée" />
        <NumberField source="status_breakdown.new_pass_2627_p0_2526" label="PASS 26-27 + P0 25-26" />
        
        {/* L1SPS 26-27 fields */}
        <NumberField source="status_breakdown.new_l1sps_2627" label="L1SPS 26-27" />
        <NumberField source="status_breakdown.new_l1sps_2627_ts_2526_done" label="L1SPS 26-27 + TS 25-26 année passée" />
        <NumberField source="status_breakdown.new_l1sps_2627_ts_2526" label="L1SPS 26-27 + TS 25-26" />
        <NumberField source="status_breakdown.new_l1sps_2627_p0_2526_done" label="L1SPS 26-27 + P0 25-26 année passé" />
        <NumberField source="status_breakdown.new_l1sps_2627_p0_2526" label="L1SPS 26-27 + P0 25-26" />
        
        {/* LAS 26-27 fields */}
        <NumberField source="status_breakdown.new_las_2627" label="LAS 26-27" />
        <NumberField source="status_breakdown.new_las_2627_ts_2526_done" label="LAS 26-27 + TS 25-26 année passée" />
        <NumberField source="status_breakdown.new_las_2627_ts_2526" label="LAS 26-27 + TS 25-26" />
        <NumberField source="status_breakdown.new_las_2627_p0_2526_done" label="LAS 26-27 + P0 25-26 année passée" />
        <NumberField source="status_breakdown.new_las_2627_p0_2526" label="LAS 26-27 + P0 25-26" />
        
        {/* Individual status fields */}
        <NumberField source="status_breakdown.new_ts_2526" label="TS 25-26" />
        <NumberField source="status_breakdown.new_ts_2627" label="TS 26-27" />
        <NumberField source="status_breakdown.new_p0_2526" label="P0 25-26" />
        <NumberField source="status_breakdown.new_p0_2627" label="P0 26-27" />
        <NumberField source="status_breakdown.new_ps_2526" label="PS 25-26" />
        <NumberField source="status_breakdown.new_ps_2627" label="PS 26-27" />
        
        {/* CRM leads count */}
        <NumberField source="crm_leads" label="Total Présents CRM" />
        <NumberField source="sub_crm_leads" label="Leads Présents Inscrits" />
        
        {/* PASS 26-27 fields */}
        <NumberField source="status_breakdown.crm_pass_2627" label="PASS 26-27" />
        <NumberField source="status_breakdown.crm_pass_2627_ts_2526" label="PASS 26-27 + TS 25-26" />
        <NumberField source="status_breakdown.crm_pass_2627_p0_2526" label="PASS 26-27 + P0 25-26" />
        
        {/* L1SPS 26-27 fields */}
        <NumberField source="status_breakdown.crm_l1sps_2627" label="L1SPS 26-27" />
        <NumberField source="status_breakdown.crm_l1sps_2627_ts_2526" label="L1SPS 26-27 + TS 25-26" />
        <NumberField source="status_breakdown.crm_l1sps_2627_p0_2526" label="L1SPS 26-27 + P0 25-26" />
        
        {/* LAS 26-27 fields */}
        <NumberField source="status_breakdown.crm_las_2627" label="LAS 26-27" />
        <NumberField source="status_breakdown.crm_las_2627_ts_2526" label="LAS 26-27 + TS 25-26" />
        <NumberField source="status_breakdown.crm_las_2627_p0_2526" label="LAS 26-27 + P0 25-26" />
        
        {/* Individual status fields */}
        <NumberField source="status_breakdown.crm_ts_2526" label="TS 25-26" />
        <NumberField source="status_breakdown.crm_ts_2627" label="TS 26-27" />
        <NumberField source="status_breakdown.crm_p0_2526" label="P0 25-26" />
        <NumberField source="status_breakdown.crm_p0_2627" label="P0 26-27" />
        <NumberField source="status_breakdown.crm_ps_2526" label="PS 25-26" />
        <NumberField source="status_breakdown.crm_ps_2627" label="PS 26-27" />
      </DatagridConfigurable>
    </List>
  )
}

export default HippocastList